


// --- React Hooks & Router Imports ---
import React, { useState, useEffect, useRef, } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box'; // Import Box for responsive sx prop
import PageWrapper from './PageWrapper'; // Import the new wrapper

import DonateComponent from 'centennial_refactor/components/donate/DonateComponent'


// --- NEW: Import styles from the dedicated style file ---




// this has the class 'section_style' / 'glow_border_class' / 'intro_heading_style'
import './style/style_centennial.css';
import 'fonts/font.css'; // Global font styles

import {
    colors,
    pageContainerStyles,
} from './PageStyles';


import './style/link_styles.css';

// import {
//     LinkStyle_01,
// } from './style/LinkStyles';




// import CollapsibleSectionNoBorder from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder';


// import CollapsibleSectionNoBorderNoButton from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderNoButton';





// used in section_01
import FadeInSectionText from 'pages_centennial/components/user_interface/FadeInSectionText'



import CollapsibleSection_01 from 'centennial_refactor/components/collapse/CollapsibleSection_01'








import { useNavigate } from 'react-router-dom';

import GODDARD_ROCKET from 'centennial_refactor/assets/goddard_rocket.png'

import PlayOnceVideo from 'pages_centennial/PlayOnceVideo';

import NewsletterForm from 'pages_public/NewsletterForm';


















// 1007
import 'pages_centennial/style/style_centennial.css';

import {

    introBannerStyles3,

    StyledMissionList,
    StyledMissionListItem,
    StyledMissionListItemNested,


    introHeadingStyles,
    introSubHeadingStyles,


    squareBulletStyle,



} from './style/PageStylesCentennial';




import CollapsibleSectionNoBorder from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder';
import CollapsibleSectionNoBorder2 from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder2';
import CollapsibleSectionNoBorderNoButton from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderNoButton';

import CollapsibleSectionNoBorderExpanded from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderExpanded';
import CollapsibleSectionNoBorderCenter from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderCenter';
import CollapsibleSectionNoBorder3 from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder3';


// import GODDARD_IMAGE from 'pages_centennial/assets/goddard.jpg'
import CENTENNIAL_LOGO_2 from 'pages_centennial/assets/centennial_images-000.png'

import SLIDE_05 from 'pages_centennial/assets/slide_5.png'
import SLIDE_06 from 'pages_centennial/assets/slide_6.png'
import SLIDE_10 from 'pages_centennial/assets/slide_10.png'
import SLIDE_11 from 'pages_centennial/assets/slide_11.png'
import SLIDE_12 from 'pages_centennial/assets/slide_12.png'
import SLIDE_13 from 'pages_centennial/assets/slide_13.png'
import SLIDE_15 from 'pages_centennial/assets/slide_15.png'
import SLIDE_16 from 'pages_centennial/assets/slide_16.png'
import SLIDE_17 from 'pages_centennial/assets/slide_17.png'
import SLIDE_18 from 'pages_centennial/assets/slide_18.png'

import wm_cw_036 from 'pages_centennial/assets/wm_cw-036.png'
import wm_cw_104 from 'pages_centennial/assets/wm_cw-104.png'

import THE_CHALLENGE from 'pages_centennial/assets/the_challenge.jpeg'










import SLIDE_01_0819 from 'pages_centennial/assets/0828/0819_SLIDE_01.png'
import SLIDE_02_0819 from 'pages_centennial/assets/0828/0819_SLIDE_02.png'
import SLIDE_03_0819 from 'pages_centennial/assets/0828/0819_SLIDE_03.png'
import SLIDE_04_0819 from 'pages_centennial/assets/0828/0819_SLIDE_04.png'
import SLIDE_05_0819 from 'pages_centennial/assets/0828/0819_SLIDE_05.png'
import SLIDE_06_0819 from 'pages_centennial/assets/0828/0819_SLIDE_06.png'
import SLIDE_07_0819 from 'pages_centennial/assets/0828/0819_SLIDE_07.png'
import SLIDE_08_0819 from 'pages_centennial/assets/0828/0819_SLIDE_08.png'
import SLIDE_09_0819 from 'pages_centennial/assets/0828/0819_SLIDE_09.png'
import SLIDE_10_0819 from 'pages_centennial/assets/0828/0819_SLIDE_10.png'
import SLIDE_11_0819 from 'pages_centennial/assets/0828/0819_SLIDE_11.png'
import SLIDE_12_0819 from 'pages_centennial/assets/0828/0819_SLIDE_12.png'

import GODDARD_HOUSE_IMAGE from './assets/hi_res/GODDARD_HOUSE_IMAGE.png'
import SPACE_TRAIL_IMAGE from './assets/hi_res/SPACE_TRAIL_1.png'

import GODDARD_PARK_IMAGE from './assets/IMG_8150.jpeg'

import LAUNCH_SITE_EVENT_IMAGE from './assets/launch_site_event/launch_site_event_collage_v2.png'


import crop_wm_cw_060 from 'pages_centennial/assets/0828/crop_wm_cw-060.png'
import IMG_today_tommorow_goddards from 'pages_centennial/assets/0901/today_tommorow_goddards_scaled.png'
import alpha_wm_cw_104 from 'pages_centennial/assets/ALPHA_wm_cw-104.png'

import IMG_today_goddards from 'pages_centennial/assets/0901/Bruce_McCandless_II_during_EVA_in_1984.jpg'

import GODDARD_IMAGE from 'pages_centennial/assets/0901/goddard.png'

// import GODDARD_ROCKET from 'pages_centennial/assets/0901/goddard_rocket.png'

import less_alpha_padding_logo from 'pages_centennial/assets/0901/less_alpha_padding_logo.png'

import OBELISK_0910 from 'pages_centennial/assets/0910/0910_OBELISK.png'


import IMG_01 from 'assets/video/01.png'
import IMG_02 from 'assets/video/02.png'
import IMG_03 from 'assets/video/03.png'
import IMG_04 from 'assets/video/04.png'
import IMG_05 from 'assets/video/05.png'
import IMG_06 from 'assets/video/06.png'
import IMG_07 from 'assets/video/07.png'
import IMG_08 from 'assets/video/08.png'
import IMG_09 from 'assets/video/wmp-177.png'
import IMG_WMP_127 from 'assets/video/wmp-127.png'

import IMG_WMP_219 from 'assets/video/wmp-219.png'
import IMG_WMP_096 from 'assets/video/wmp-096_crop.png'

import IMG_WMP_071 from 'assets/video/wmp-071.png'
import IMG_WMP_001 from 'assets/video/wmp-001.png'





import CountdownTimer from './components/countdown/CountdownTimer'







import ECOTARIUM_SECTION_IMAGE from './assets/ecotarium_planetarium_with_logo.png'

















const CentennialPageRefactor = () => {





    const navigate = useNavigate();

    const handleLearnMoreClick = (url) => {
        console.log('click')
        if (url) {
            navigate(url);
        }
    };




    const handleLearnMoreClickExternal = (url) => {
        if (url) {
            // '_blank' opens in new tab
            // 'noopener,noreferrer' is a security best practice for external links
            // window.open(url, '_blank', 'noopener,noreferrer');
            window.open(url, 'noopener,noreferrer');
        }
    };





    // 2. Updated function to handle both navigation and scrolling
    const handleNavigateAndScroll = (url) => {
        console.log('click and scroll');

        // --- SCROLL TO TOP LOGIC ---
        // Check if the ref is attached and has a scroll method (for a scrollable container)
        // OR, more reliably for the entire window/document:
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: Makes the scroll smooth
        });

        // If the main div (pageRef.current) is the scrollable container, use this instead:
        // if (pageRef.current) {
        //     pageRef.current.scrollTo({
        //         top: 0,
        //         behavior: 'smooth'
        //     });
        // }
        // -----------------------------

        // 3. Perform the navigation after the scroll
        if (url) {
            // Use a short delay if scrolling the pageRef container to allow the DOM to update,
            // but for window.scrollTo, it's usually fine to run immediately.
            navigate(url);
        }
    };









    let subscriptionOptionsRenderArray = [
        {
            id: 1,
            name: 'test name',
            price: '0.00',
            stripe_reference_key: 'price_1S7N65KE0e1CFeGpTc6cJJI8',
            courses: [1, 2, 3]
        }
    ]


    let user_email = 'test@test.com'


    let index = 0












    return (
        <PageWrapper navbarPermanent={true}>
            {/* <h1>test</h1> */}


            {/* <CollapsibleSectionNoBorder>
                </CollapsibleSectionNoBorder>

                <CollapsibleSectionNoBorderNoButton>
                </CollapsibleSectionNoBorderNoButton> */}








            {/* <div class="section_style">
                    <CollapsibleSectionNoBorder
                        title="Our Mission:"
                        summary="Inspiring our next generation."
                        imageSrc=''
                        imageAlt=""
                        fullText=" "
                        // learnMoreLink="/missionstatement"
                        // learnMoreText="Learn About The Wonder Mission"
                        delay={0.0}
                    >
                        <div>
                            <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                                The Wonder Mission, a 501(c)(3) nonprofit organization,  was specifically founded to reverse this trend by launching a series of creative initiatives to help alter this troubling trend and inspire our next generation of those who dream big.
                            </p>
                            <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                                The Mission aims to spark imagination and remind the public that anything is possible. As  Goddard once said: “It is difficult to say what is impossible, for the dream of yesterday is the hope of today and the reality of tomorrow.”
                            </p>
                            <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                                The Wonder Mission invites everyone to dream big, explore boldly, and help shape a future where science and wonder are part of everyday life.
                            </p>
                        </div>
                    </CollapsibleSectionNoBorder>
                </div>
                
                
                // style={{ fontFamily: 'roboto_regular', fontSize: '1.2rem', maxWidth: '500px', color: colors.textColor, margin: '1rem' }}
                // 
                // */}





            <div style={{ marginTop: '2rem' }}>

            </div>

            <p></p>


            <FadeInSectionText delay={0.2}>
                <p class="p_style_01"
                    style={{
                        color: 'white',
                        textAlign: 'center',
                        fontSize: '1.2rem',
                        //fontFamily: 'orbitron_regular', 
                        padding: '0rem',
                        marginBottom: '1rem',
                        marginTop: '2rem',
                        fontFamily: 'orbitron_regular', color: 'white', letterSpacing: '2px'
                    }}

                >
                    <a style={{ textDecoration: 'underline', color: colors.accentColor }} href='https://goddard.printful.me/'
                        target="_blank"
                    >Check out our Merchandise!</a>
                </p>

            </FadeInSectionText>


            <PlayOnceVideo></PlayOnceVideo>




            <FadeInSectionText delay={0.5}>
                <div style={{ marginBottom: '0rem', marginTop: '1rem' }}>

                    <div
                        onClick={() => handleLearnMoreClickExternal('https://thehanovertheatre.org/event/goddard-father-of-the-space-age/')}
                        className="div_button_style_02"
                        style={{ padding: '0.5rem', border: '1px solid white' }}
                    >
                        <p class="p_style_01"
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: '1.3rem',
                                //fontFamily: 'orbitron_regular', 
                                padding: '0rem',
                                margin: '0rem',
                            }}

                        >
                            <b style={{ color: colors.accentColor, letterSpacing: '2px' }}>RESERVE FREE TICKETS NOW!</b>
                        </p>


                        {/* <p class="p_style_01"
                        style={{
                            color: 'white',
                            textAlign: 'center',
                            fontSize: '1.2rem',
                            // fontFamily: 'orbitron_regular', 
                            padding: '0rem',
                            margin: '0rem',
                        }}

                    >
                        for the
                    </p> */}

                        <p class="p_style_01"
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: '1.1rem',
                                //fontFamily: 'orbitron_regular', 
                                padding: '0rem',
                                margin: '0rem',
                            }}

                        >
                            Goddard Hanover Theater Celebration
                        </p>

                        <p class="p_style_01"
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: '1.1rem',
                                //fontFamily: 'orbitron_regular', 
                                padding: '0rem',
                                margin: '0rem',
                            }}

                        >
                            Sunday, March 22nd, 4:30pm
                        </p>




                        <p
                            style={{
                                padding: '0rem',
                                margin: '0rem',
                                fontSize: '0.9rem',
                                textAlign: 'center',
                                color: "white",
                            }}
                        >( Click to Reserve Tickets )</p>

                    </div>

                </div>
            </FadeInSectionText>
















            {/* <div style={{ marginBottom: '0rem', marginTop: '1rem' }}>

                <div
                    onClick={() => handleLearnMoreClickExternal('https://thehanovertheatre.org/event/goddard-father-of-the-space-age/')}
                    className="div_button_style_02"
                    style={{ padding: '0.5rem', border: '1px solid white' }}
                >
                    <p class="p_style_01"
                        style={{
                            color: 'white',
                            textAlign: 'center',
                            fontSize: '1.5rem',
                            //fontFamily: 'orbitron_regular', 
                            padding: '0rem',
                            margin: '0rem',
                        }}

                    >
                        <b style={{ color: colors.accentColor, letterSpacing: '2px' }}>GET MERCHANDISE</b>
                    </p>


                </div>

            </div> */}


















            <div class="section_style" id='section_01'>



                {/* <FadeInSectionText delay={0.0}> */}

                <div>
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, }}
                    >MARCH 16, 2026</h1>
                </div>

                {/* </FadeInSectionText> */}


                {/* <FadeInSectionText delay={0.2}> */}
                <div>
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, margin: '1rem' , marginBottom:'3rem',}}
                    >FIRST LAUNCH CENTENNIAL</h1>
                </div>
                {/* </FadeInSectionText> */}


                {/* <div>
                    <CountdownTimer></CountdownTimer>
                </div> */}




                {/* <p class="p_style_01">
                    As featured in USA TODAY
                </p> */}







                <div
                    onClick={() => handleLearnMoreClickExternal('https://www.usatoday.com/story/special/contributor-content/2025/11/20/the-wonder-mission-a-new-vision-for-science-storytelling-and-national-inspiration/87380114007/')}
                    className="div_button_style_02"

                >
                    <p class="p_style_01"
                        style={{
                            padding: '0rem',
                            margin: '0rem',
                        }}

                    >
                        <b>As featured in USA TODAY</b>
                    </p>
                    <p
                        style={{
                            padding: '0rem',
                            margin: '0rem',
                        }}
                    >(Click to view USA TODAY article)</p>

                </div>




















                <p class="p_style_01">
                    Celebrating the 100th anniversary of the first modern rocket launch by
                    {/* <br></br>
                    <br></br>
                    <b>Dr. Robert H. Goddard</b> */}
                </p>











                <div
                    onClick={() => handleLearnMoreClick('/robertgoddard')}
                    className="div_button_style_02"

                // style={{
                //     backgroundColor: 'rgba(25, 171, 240,0.20)',
                //     padding: '1rem', borderRadius: '1rem',
                //     cursor: 'pointer'
                // }}

                >
                    <p class="p_style_01"
                        style={{
                            //backgroundColor: 'rgba(25, 171, 240,0.20)',
                            padding: '0rem',
                            margin: '0rem',
                            // borderRadius: '1rem',
                            // cursor: 'pointer'
                        }}

                    >
                        <b>Dr. Robert H. Goddard</b>
                    </p>
                    <p
                        style={{
                            //backgroundColor: 'rgba(25, 171, 240,0.20)',
                            padding: '0rem',
                            margin: '0rem',
                        }}
                    >(Click to learn more about Dr. Goddard)</p>

                </div>



                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    display: 'flex',
                    justifyContent: 'space-evenly',


                }}>

                    {/* <div
                        style={{
                            //sboxShadow: '0px 0px 10px 5px rgba(21, 140, 196, 0.7)',
                            margin: '2rem',
                            //boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                        }}>
                        <div
                            style={{
                                // boxShadow: '0px 0px 10px 5px rgba(21, 140, 196, 0.7)',
                                margin: '0rem',
                                // borderRadius:'50%'
                                //boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            }}> */}

                    <img
                        src={GODDARD_ROCKET}
                        //class="glow_border_class"
                        style={{
                            maxWidth: '70%',
                            //maxHeight: '15rem',
                            margin: '2rem',
                            padding: '0rem',
                            width: 'auto',
                            height: 'auto',
                            borderRadius: '50%',
                            objectFit: 'contain',
                            // boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            // border: `1px solid ${colors.cardBorder}80`,
                            //boxShadow: '0px 0px 10px 5px rgba(21, 140, 196, 0.7)',

                            // ✅ ADD THIS INSTEAD:
                            //filter: `drop-shadow(rgba(21, 140, 196, 1) 0px 0px 15px)`,

                            // border: `1px solid rgba(21, 140, 196, 0.5)`,
                            // filter: `drop-shadow(0px 0px 10px rgba(21, 140, 196, 0.8)) drop-shadow(0px 0px 5px rgba(21, 140, 196, 1))`,


                            border: `1px solid rgba(21, 140, 196, 0.5)`,
                            filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,



                            // filter: `drop-shadow(0px 0px 10px 5px rgba(21, 140, 196, 1) )`,


                        }}
                    />

                    {/* </div>

                    </div> */}


                </div>

                <p class="p_style_02" style={{ color: colors.accentColor, margin: '0rem', padding: '0rem' }}>
                    Humanity's first steps to the stars,
                    <br></br>and the dawn of the SPACE AGE!
                </p>

                <p
                    class="p_style_02"
                    style={{
                        //backgroundColor: 'rgba(25, 171, 240,0.20)',
                        padding: '0rem',
                        margin: '1rem',
                        fontSize: '0.9rem',
                        textAlign: 'center',
                        maxWidth: '500px',
                        color: '#d6d7d9', // aeb0b5 e4e2e0 d6d7d9
                        opacity: '55%'
                    }}
                >( Images of Dr. Goddard courtesy of Clark University and WPI Archives and Special Collections )</p>
                {/* <p class="p_style_01">
                    An Initiative of
                </p>

                <p class="p_style_01"
                    style={{ backgroundColor: 'rgba(25, 171, 240,0.20)', padding: '1rem', borderRadius: '1rem', cursor: 'pointer' }}
                    onClick={() => handleLearnMoreClick('/about')}
                >
                    <b>The Wonder Mission</b>
                </p> */}


            </div>















































































            <div class="section_style">
                <div >
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, marginTop: '2rem' }}>
                        WORCESTER CENTENNIAL CELEBRATIONS</h1>
                </div>



                <div >
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.textColor, marginBottom: '3rem' }}>
                        The Week at a Glance</h1>
                </div>


















                <div style={{ margin: '1rem' }}>
                    <StyledMissionList>
                        {/* <StyledMissionListItem>
                                <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>SATURDAY, March 14</span>
                                <StyledMissionList>
                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        "From Here to the Stars"
                                    </StyledMissionListItemNested>
                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Goddard Film Festival
                                    </StyledMissionListItemNested>
                                </StyledMissionList>
                            </StyledMissionListItem> */}








                        {/* <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>THURSDAY, March 12</span>
                            <StyledMissionList>



                                <StyledMissionListItemNested>


                                    <span style={{ fontWeight: 'bold' }}>
                                        Museum of Worcester: Robert Goddard Exhibit VIP Event
                                    </span>


                                </StyledMissionListItemNested>



                            </StyledMissionList>
                        </StyledMissionListItem> */}









                        {/* <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Robert Goddard Exhibit (Until Fall 2026) */}



                        {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Goddard Film Festival
                                    </StyledMissionListItemNested> */}

                        {/* 
                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Centennial Reception</span>
                                        (Date TBD in March)
                                    </StyledMissionListItemNested> */}































                        <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>SATURDAY, March 14</span>
                            <StyledMissionList>





                                <StyledMissionListItemNested>
                                    <p style={{ fontWeight: 'bold', }}>
                                        <span style={{

                                            //color: colors.accentColor,
                                            // fontFamily: 'roboto_regular'
                                        }}> RESCHEDULED DATE FOR LAUNCH SITE EVENT - </span>

                                        Auburn, MA<br></br>

                                        <span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            // fontFamily: 'roboto_regular'
                                        }}>
                                            1:00 pm
                                        </span>


                                    </p>

                                    {/* <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        DUE TO A SEVERE WEATHER ALERT FOR MONDAY MARCH 16
                                        <br></br>THE LAUNCH CELEBRATION HAS BEEN MOVED UP 2 DAYS
                                    </p>
                                    <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        THIS EVENT HAS BEEN RESCHEDULED TO
                                        <br></br>SATURDAY MARCH 14 AT 1:00 PM
                                    </p> */}

                                </StyledMissionListItemNested>






                                <StyledMissionListItemNested>

                                    <span style={{ fontWeight: 'bold' }}>
                                        Rededication of Goddard Park <br></br><span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            // fontFamily: 'roboto_regular'
                                        }}>
                                            10:00 am - 5:00 pm
                                        </span>
                                    </span>

                                </StyledMissionListItemNested>



                                <StyledMissionListItemNested>


                                    <p style={{ fontWeight: 'bold' }}>
                                        Family Fun Festival
                                    </p>


                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://www.auburnma.gov/839/Robert-Goddard-Centennial" target="_blank">More Details at:<br></br>www.auburnma.gov</a>
                                    </p>


                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"

                                            href="https://goddard100th.org" target="_blank">More Details at:<br></br>goddard100th.org</a>
                                    </p>


                                </StyledMissionListItemNested>


                            </StyledMissionList>
                        </StyledMissionListItem>








                        <StyledMissionListItem>

                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>SUNDAY, March 15</span>

                            <StyledMissionList>



                                <StyledMissionListItemNested>

                                    <span >
                                        Goddard Rocket Centennial Celebration<br></br><br></br>
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"

                                            href="https://ecotarium.org/event/goddard-centennial/" target="_blank">More Details at:<br></br>ecotarium.org/event</a>
                                    </span>

                                </StyledMissionListItemNested>



                            </StyledMissionList>
                        </StyledMissionListItem>





                        {/* <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>SUNDAY, March 15 - TUESDAY, March 17</span>
                            <StyledMissionList> */}

                        {/* <StyledMissionListItemNested>
                                    <span style={{ fontWeight: 'bold' }}>Searchlights: "From Here to the Stars" </span> */}

                        {/* <span style={{
                                        fontWeight: 'bold',
                                        color: colors.accentColor,
                                        // fontFamily: 'roboto_regular'
                                    }}>(March 15 - 17)
                                    </span> */}

                        {/* </StyledMissionListItemNested> */}


                        {/* <StyledMissionListItemNested> */}

                        {/* <span style={{ fontWeight: 'bold' }}>
                                        Museum of Worcester: Robert Goddard Exhibit Opens
                                    </span> */}

                        {/* <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Robert Goddard Exhibit (Until Fall 2026) */}


                        {/* </StyledMissionListItemNested> */}



                        {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Goddard Film Festival
                                    </StyledMissionListItemNested> */}

                        {/* 
                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Centennial Reception</span>
                                        (Date TBD in March)
                                    </StyledMissionListItemNested> */}


                        {/* </StyledMissionList>
                        </StyledMissionListItem> */}























                        <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold', }}>MONDAY, March 16</span>
                            <StyledMissionList>



                                <StyledMissionListItemNested>





                                    <p style={{ fontWeight: 'bold', textDecoration: 'line-through' }}>
                                        <span style={{

                                            //color: colors.accentColor,
                                            // fontFamily: 'roboto_regular'
                                        }}> LAUNCH SITE EVENT - </span>

                                        Auburn, MA<br></br>

                                        <span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            // fontFamily: 'roboto_regular'
                                        }}>
                                            10:00 am - 5:00 pm
                                        </span>


                                    </p>

                                    {/* <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        DUE TO A SEVERE WEATHER ALERT FOR MONDAY MARCH 16
                                        <br></br>THE LAUNCH CELEBRATION HAS BEEN MOVED UP 2 DAYS
                                    </p>
                                    <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        THIS EVENT HAS BEEN RESCHEDULED TO
                                        <br></br>SATURDAY MARCH 14 AT 1:00 PM
                                    </p> */}


                                    <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        DUE TO A SEVERE WEATHER ALERT FOR MONDAY MARCH 16
                                        <br></br>THE LAUNCH CELEBRATION WAS MOVED UP 2 DAYS
                                    </p>
                                    <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        THIS EVENT TOOK PLACE ON
                                        <br></br>SATURDAY MARCH 14 AT 1:00 PM
                                    </p>



                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"

                                            href="https://www.auburnma.gov/839/Robert-Goddard-Centennial" target="_blank">More Details at:<br></br>www.auburnma.gov</a>
                                    </p>


                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"

                                            href="https://goddard100th.org" target="_blank">More Details at:<br></br>goddard100th.org</a>
                                    </p>



                                </StyledMissionListItemNested>

                                {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Centennial Day Event - ACROSS THE COUNTRY</span>
                                    </StyledMissionListItemNested> */}

                                <StyledMissionListItemNested>
                                    <span style={{ fontWeight: 'bold' }}>Model Rockets Launched Across the Country</span>
                                </StyledMissionListItemNested>

                                <StyledMissionListItemNested>
                                    <span style={{ fontWeight: 'bold' }}>
                                        Museum of Worcester: Robert Goddard Exhibit Public Opening
                                    </span>
                                </StyledMissionListItemNested>





                                {/* <StyledMissionListItemNested>
                                        <span >Searchlights: "From Here to the Stars" </span>
                                    </StyledMissionListItemNested> */}

                                {/* <StyledMissionListItemNested>
                                        <span >Museum of Worcester: </span>
                                        Robert Goddard Exhibit (Until Fall 2026)
                                    </StyledMissionListItemNested> */}

                            </StyledMissionList>
                        </StyledMissionListItem>











                        <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>TUESDAY, March 17 - SATURDAY, March 21</span>
                            <StyledMissionList>


                                <StyledMissionListItemNested>
                                    <span style={{ fontWeight: 'bold' }}>National Space Trail Tours </span>

                                    {/* <span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            fontFamily: 'roboto_regular'
                                        }}>(March 17 - 21)
                                        </span> */}

                                </StyledMissionListItemNested>
                                <StyledMissionListItemNested>
                                    <span style={{ fontWeight: 'bold' }}>Goddard House Tours and Presentations</span>
                                    <br></br>

                                    <span style={{
                                        fontWeight: 'bold',
                                        color: colors.accentColor,
                                        // fontFamily: 'roboto_regular'
                                    }}>10:00 am - 12:00 pm and
                                    </span>
                                    <br></br>
                                    <span style={{
                                        fontWeight: 'bold',
                                        color: colors.accentColor,
                                        // fontFamily: 'roboto_regular'
                                    }}>2:00 pm - 4:00 pm
                                    </span>
                                    <br></br>
                                    <span
                                    >1 Tallawanda Dr, Worcester, MA 01603
                                    </span>


                                    {/* <span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            fontFamily: 'roboto_regular'
                                        }}>(March 17 - 21)
                                        </span> */}
                                </StyledMissionListItemNested>


                                {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>CLARK and WPI Campus Presentations  </span>
                                        <span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            fontFamily: 'roboto_regular'
                                        }}>(March 17 - 22)
                                        </span>
                                    </StyledMissionListItemNested> */}


                                {/* <StyledMissionListItemNested>
                                        <span >"From Here to the Stars" </span>
                                    </StyledMissionListItemNested> */}


                                {/* <StyledMissionListItemNested>
                                        <span >Museum of Worcester: </span>
                                        Robert Goddard Exhibit (Until Fall 2026)
                                    </StyledMissionListItemNested> */}


                            </StyledMissionList>
                        </StyledMissionListItem>














                        <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>TUESDAY, March 17 - SUNDAY, March 22</span>
                            <StyledMissionList>

                                {/* <StyledMissionListItemNested>
                                    <span style={{ fontWeight: 'bold' }}>Clark and WPI Campus Presentations  </span> */}
                                {/* <span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            fontFamily: 'roboto_regular'
                                        }}>(March 17 - 22)
                                        </span> */}
                                {/* </StyledMissionListItemNested> */}

                                <StyledMissionListItemNested>
                                    {/* <span style={{ fontWeight: 'bold' }}>Clark University Presentations</span><br></br> */}
                                    <p style={{ fontWeight: 'bold' }}>Clark University Events:</p>
                                    <p>
                                        Full Events List: Robert Goddard Rocket Launch Centennial
                                    </p>

                                    <p >
                                        <a
                                            // style={{
                                            //     textDecoration: 'underline',
                                            //     color: '#5bbaf5',
                                            //     overflowWrap: 'break-word',
                                            // }}

                                            class="link_style_01"
                                            href="https://www.clarku.edu/events/all-campus-events/tag/goddard-centennial/" target="_blank">More Details at:<br></br>www.clarku.edu/events</a>
                                    </p>




                                    {/* 

                                    4287f5
                                    19abf0 
                                    
                                    0b6d9c
                                    54c3f7
                                    42bbf5

7fd3fa
6bbce3

5bbaf5

                                    */}


                                    <br></br>
                                    <br></br>





                                    <p>Clark Goddard Microsite</p>
                                    <p>


                                    </p>


                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href=" https://www.clarku.edu/goddard/" target="_blank">More Details Here

                                            {/* <br></br>www.clarku.edu/events<br></br>/event/john-emond-goddard-vision-reality-hope/ */}

                                        </a>
                                    </p>
                                    <br></br>
                                    <br></br>





                                    <p>Robert Goddard: A Vision. A Reality. A Hope</p>
                                    <p>
                                        March 17 @ 7:00 p.m. - 8:00 p.m
                                    </p>


                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://www.clarku.edu/events/event/john-emond-goddard-vision-reality-hope/" target="_blank">More Details Here

                                            {/* <br></br>www.clarku.edu/events<br></br>/event/john-emond-goddard-vision-reality-hope/ */}

                                        </a>
                                    </p>




                                    <br></br>
                                    <br></br>




                                    <p>Robert Goddard: The Dreamer Who Launched the Space Age</p>
                                    <p>
                                        March 19 @ 4:00 p.m. – 6:00 p.m.
                                    </p>


                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://www.clarku.edu/events/event/robert-goddard-the-dreamer-who-launched-the-space-age/" target="_blank">More Details Here

                                            {/* <br></br>www.clarku.edu/events<br></br>/event/john-emond-goddard-vision-reality-hope/ */}

                                        </a>
                                    </p>





                                    {/* <span>
                                    <a style={{textDecoration:'none',color:'white'}} href="https://www.auburnma.gov">(click for more information)</a>
                                        
                                    </span> */}


                                </StyledMissionListItemNested>
                                <br></br>
                                <br></br>

                                <StyledMissionListItemNested>
                                    {/* <span style={{ fontWeight: 'bold' }}>Worcester Polytechnic Institute Campus Presentations</span><br></br> */}
                                    <p style={{ fontWeight: 'bold' }}>WPI Events:</p><br></br>

                                    {/* <p style={{ fontWeight: 'bold' }}>
                                        <a style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} href="https://www.wpi.edu/news/calendar" target="_blank">All WPI events can be found at https://<br></br>www.wpi.edu<br></br>/news/calendar</a>
                                    </p> */}








                                    <p>Pop-up Exhibit #2 ft. WPI's Robert and Esther Goddard Collection: Where the Space Age Began</p>

                                    <p>
                                        Tuesday, March 17, 2026
                                        11:30 a.m. to 1:00 p.m.
                                    </p>

                                    <p>
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://www.wpi.edu/news/calendar/events/pop-exhibit-2-ft-wpis-robert-and-esther-goddard-collection-where-space-age-began" target="_blank">More Details Here</a>
                                    </p>



                                    <br></br>
                                    <br></br>

                                    <p>Pop-up Exhibit #3 ft. WPI’s Robert and Esther Goddard Collection: Where the Space Age Began</p>
                                    <p>
                                        Wednesday, March 18, 2026
                                        12:30 p.m. to 2:00 p.m.
                                    </p>
                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://www.wpi.edu/news/calendar/events/pop-exhibit-3-ft-wpis-robert-and-esther-goddard-collection-where-space-age-began" target="_blank"> More Details Here</a>
                                    </p>






                                    <br></br>
                                    <br></br>



                                    <p>Launching the Next 100 Years: Industry, Innovation & the Future of Space</p>
                                    <p>
                                        Wednesday, March 18, 2026
                                        5:30 p.m. to 7:00 p.m.
                                    </p>
                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://www.wpi.edu/news/calendar/events/launching-next-100-years-industry-innovation-future-space/" target="_blank"> More Details Here</a>
                                    </p>

                                    <br></br>
                                    <br></br>



                                    <p>Goddard's Life and Legacy Exhibits at WPI:</p>

                                    <p>
                                        A new digital exhibit on Goddard's student years and pioneering work.
                                    </p>

                                    <p>
                                        An interactive physical display will be available March 4, 17, and 18.
                                    </p>

                                    <p>
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://exhibits.wpi.edu/spotlight/goddard/" target="_blank"> More Details Here</a>
                                    </p>

                                    <br></br>
                                    <br></br>



















                                    <p>WPI Music at Mechanics Hall</p>
                                    <p>
                                        Sunday, April 19, 2026
                                        4:00 p.m. to 6:00 p.m.
                                    </p>
                                    <p >
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                            class="link_style_01"
                                            href="https://www.wpi.edu/news/calendar/events/wpi-music-mechanics-hall" target="_blank">More Details Here</a>
                                    </p>



                                </StyledMissionListItemNested>









                            </StyledMissionList>
                        </StyledMissionListItem>














                        {/* <StyledMissionListItem>
                                <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>WEDNESDAY, March 18 - FRIDAY, March 20</span>
                                <StyledMissionList>

                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>National Space Trail Tours</span>
                                    </StyledMissionListItemNested>
                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Goddard House Tours</span>
                                    </StyledMissionListItemNested>
                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>CLARK and WPI Presentations</span>
                                    </StyledMissionListItemNested>

                                </StyledMissionList>
                            </StyledMissionListItem> */}







                        {/* 
                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Robert Goddard Exhibit (Until Fall 2026)
                                    </StyledMissionListItemNested> */}
















                        {/* <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>SATURDAY, March 21</span>
                            <StyledMissionList>


                                <StyledMissionListItemNested>
                                    <span style={{ fontWeight: 'bold' }}>WPI - Touch Tomorrow Event</span>
                                </StyledMissionListItemNested> */}

                        {/* 

                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>CLARK and WPI Presentations</span>
                                    </StyledMissionListItemNested>

                                    <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Goddard House Tours</span>
                                    </StyledMissionListItemNested> */}

                        {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>National Space Trail Tours</span>
                                    </StyledMissionListItemNested> */}

                        {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Robert Goddard Exhibit (Until Fall 2026)
                                    </StyledMissionListItemNested> */}

                        {/* </StyledMissionList>
                        </StyledMissionListItem> */}

















                        <StyledMissionListItem>
                            <span style={{ color: colors.accentColor, fontWeight: 'bold' }}>SUNDAY, March 22</span>
                            <StyledMissionList>
                                <StyledMissionListItemNested>

                                    {/* <span style={{ fontWeight: 'bold' }}>Centennial Gala at Hanover Theater </span> */}

                                    <p style={{ fontWeight: 'bold' }}>Goddard Celebration at Hanover Theater</p>




                                    <p style={{
                                        fontWeight: 'bold',
                                        color: colors.accentColor,
                                        // fontFamily: 'roboto_regular'
                                    }}>4:30 pm - 6:00 pm
                                    </p>

                                    <p style={{
                                        fontWeight: 'bold',
                                        color: colors.accentColor,
                                        // fontFamily: 'roboto_regular'
                                    }}>Doors Open at 3:30 pm
                                    </p>

                                    <p>
                                        <a

                                            // style={{ textDecoration: 'none', color: 'white' }} 

                                            class="link_style_01"

                                            href="https://thehanovertheatre.org/event/goddard-father-of-the-space-age/"

                                            target="_blank"

                                        >CLICK HERE for FREE TICKETS</a>
                                    </p>


                                </StyledMissionListItemNested>



                                {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>CLARK and WPI Campus Presentations  </span>
                                        <span style={{
                                            fontWeight: 'bold',
                                            color: colors.accentColor,
                                            fontFamily: 'roboto_regular'
                                        }}>(March 17 - 22)
                                        </span>
                                    </StyledMissionListItemNested> */}



                                {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>CLARK and WPI Presentations</span>
                                    </StyledMissionListItemNested> */}





                                {/* <StyledMissionListItemNested>
                                        <span style={{ fontWeight: 'bold' }}>Museum of Worcester: </span>
                                        Robert Goddard Exhibit (Until Fall 2026)
                                    </StyledMissionListItemNested> */}


                            </StyledMissionList>
                        </StyledMissionListItem>
                    </StyledMissionList>
                </div>


































                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    display: 'flex',
                    justifyContent: 'space-evenly'
                }}>

                    <img
                        src={CENTENNIAL_LOGO_2}
                        // class="glow_border_class"
                        style={{
                            maxWidth: '70%',
                            //maxHeight: '15rem',
                            margin: '2rem',
                            padding: '0rem',
                            width: 'auto',
                            height: 'auto',
                            // borderRadius: '50%',
                            objectFit: 'contain',

                            // boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            // border: `1px solid ${colors.cardBorder}80`,

                            //border: `1px solid rgba(21, 140, 196, 0.5)`,
                            filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,


                            maxWidth: '80%',
                            maxHeight: '20rem',
                            objectFit: 'contain',

                        }}
                    />



                </div>


































            </div>



            <div class="section_style">
                <div >
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, marginTop: '2rem' }}>
                        WORCESTER CENTENNIAL CELEBRATIONS</h1>
                </div>



                <div >
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.textColor, marginBottom: '3rem' }}>
                        Event Details</h1>
                </div>









                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}


                {/* <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 15-17
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                }}>
                                Searchlights: "From Here To The Stars"
                            </h1>
                        </div>

                    </div> */}










                {/* <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SLIDE_02_0819}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div> */}







                {/* <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SLIDE_02_0819}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    // padding: '1rem',

                                    borderRadius: '2rem',


                                }}
                            />


                        </div>
                    </div> */}







                {/* <img
                        src={SLIDE_02_0819}
                        alt="IMG_02"
                        style={{
                            width: 'auto',
                            maxWidth: '80%',
                            margin: '1rem',
                            maxHeight: '20rem',
                            objectFit: 'contain',
                            // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            // border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                        }}
                    /> */}







                {/* <img
                        src={SLIDE_02_0819}
                        alt="IMG_02"
                        style={{
                            width: 'auto',
                            maxWidth: '80%',
                            margin: '1rem',
                            maxHeight: '20rem',
                            objectFit: 'contain',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                        }}
                    /> */}






















                {/* <CollapsibleSection_01
                        title=""
                        summary=""
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >
                        <div>

                            <p>

                                Multiple searchlights pointing skyward from near Goddard's historic launch site.

                            </p>


                            <p>

                                Similar to “The Tribute of Lights” for the World Trade Center Memorial.

                            </p>
                        </div>
                    </CollapsibleSection_01>
                </div> */}


                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}



































































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}



                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 14, 2026
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginBottom: '0rem'
                                }}>
                                Dr. Robert H. Goddard Park
                                {/* <br></br><br></br>
                                <span style={{ padding: '1rem' }}>10:00 am - 5:00 pm</span>
                                <br></br> */}
                                {/* 341-357 Southbridge St, Auburn, MA 01501 */}
                                {/* At Launch Site 12 pm - 2 pm */}
                            </h1>


                            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                    <p style={{
                                        padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center',
                                        fontFamily: 'orbitron_medium',
                                        color: colors.accentColor,

                                    }}>10:00 am - 5:00 pm</p>
                                </div>
                            </div>


                            <p
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.3rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginTop: '0rem',
                                    color: '#bbbbbb'
                                }}>
                                Address: 341-357 Southbridge St, Auburn, MA 01501
                            </p>

                        </div>

                    </div>





                    <img
                        src={GODDARD_PARK_IMAGE}
                        alt="IMG_02"
                        style={{
                            width: 'auto',
                            maxWidth: '80%',
                            margin: '1rem',
                            maxHeight: '20rem',
                            objectFit: 'contain',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                        }}
                    />








                    <CollapsibleSection_01
                        title=""
                        summary=""
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >





                        <div style={{
                            width: '100%',
                        }}>
                            <div
                            // style={{maxWidth:'800px', backgroundColor:'gray'}}
                            >




                                <ul>
                                    <li style={squareBulletStyle}>
                                        Family Fun Festival
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Historical Reenactors
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Scavenger Hunt
                                    </li>

                                    <li style={squareBulletStyle}>

                                        STEM Panel
                                    </li>

                                    <li style={squareBulletStyle}>

                                        Food Trucks
                                    </li>


                                </ul>




                                <p style={{ fontWeight: 'bold' }}>
                                    <br></br>
                                    <a

                                        // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                        class="link_style_01"
                                        href="https://www.auburnma.gov/839/Robert-Goddard-Centennial" target="_blank">Details at https://www.auburnma.gov /839/Robert-Goddard-Centennial</a>
                                </p>

                                <p style={{ fontWeight: 'bold' }}>
                                    <a

                                        // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                        class="link_style_01"

                                        href="https://www.auburnma.gov/839/Robert-Goddard-Centennial" target="_blank">https://<br></br>goddard100th.org</a>
                                </p>


                            </div>

                        </div>





                    </CollapsibleSection_01>



















                </div>

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

























































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}



                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                {/* SUNDAY<br></br> */}
                                MARCH 15, 2026
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginBottom: '0rem'
                                }}>
                                EcoTarium: Goddard Rocket Centennial Celebration
                                {/* <br></br><br></br>
                                <span style={{ padding: '1rem' }}>10:00 am - 5:00 pm</span>
                                <br></br> */}
                                {/* 341-357 Southbridge St, Auburn, MA 01501 */}
                                {/* At Launch Site 12 pm - 2 pm */}
                            </h1>


                            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                    <p style={{
                                        padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center',
                                        fontFamily: 'orbitron_medium',
                                        color: colors.accentColor,

                                    }}>10:00 am - 5:00 pm</p>
                                </div>
                            </div>


                            <p
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.3rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginTop: '0rem',
                                    color: '#bbbbbb'
                                }}>
                                Address: 222 Harrington Way, Worcester, MA 01604
                            </p>

                        </div>

                    </div>





                    <img
                        src={ECOTARIUM_SECTION_IMAGE}
                        alt="IMG_02"
                        style={{
                            width: 'auto',
                            maxWidth: '80%',
                            margin: '1rem',
                            maxHeight: '20rem',
                            objectFit: 'contain',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                        }}
                    />








                    <CollapsibleSection_01
                        title=""
                        summary=""
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >





                        <div style={{
                            width: '100%',
                        }}>




                            <div
                            // style={{maxWidth:'800px', backgroundColor:'gray'}}
                            >






                                <p>Join us to celebrate the 100 year anniversary of Robert Goddard's historic first ever liquid-fueled rocket launch in March 1926 right here in Central Massachusetts!

                                </p>
                                <p>Learn about how scientists have used rockets for over 100 years to explore the far reaches of space, and witness a model rocket launch at 12:30 pm. It really is rocket science!</p>


                                <p style={{ fontWeight: 'bold' }}>
                                    <a

                                        // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                        class="link_style_01"

                                        href="https://ecotarium.org/event/goddard-centennial/" target="_blank">More EcoTarium Event Details at https://ecotarium.org /event/goddard-centennial</a>
                                </p>


                            </div>





                            {/* https://ecotarium.org/event/goddard-centennial/



https://2573.blackbaudhosting.com/2573/page.aspx?pid=213&tab=2&txobjid=e18eb5b4-fb22-4b8a-8ad7-868ad7beb226



https://2573.blackbaudhosting.com/2573/page.aspx?pid=213&tab=2&txobjid=e18eb5b4-fb22-4b8a-8ad7-868ad7beb226
 */}



                            <div style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>


                                <div
                                    onClick={() => handleLearnMoreClickExternal('https://2573.blackbaudhosting.com/2573/page.aspx?pid=213&tab=2&txobjid=e18eb5b4-fb22-4b8a-8ad7-868ad7beb226')}
                                    className="div_button_style_02"
                                    style={{
                                        margin: '1rem', padding: '0.5rem', border: '1px solid white', maxWidth: '700px',

                                    }}
                                >
                                    <p class="p_style_03"
                                        style={{
                                            color: 'white',
                                            textAlign: 'center',
                                            fontSize: '1.5rem',
                                            //fontFamily: 'orbitron_regular', 
                                            padding: '0rem',
                                            margin: '0rem',
                                        }}

                                    >
                                        <b style={{ color: colors.accentColor, letterSpacing: '2px' }}>GET TICKETS NOW!</b>
                                    </p>







                                    <p class="p_style_03"
                                        style={{
                                            padding: '0rem',
                                            margin: '0rem',
                                            fontSize: '1rem',
                                            textAlign: 'center',
                                            color: "white",
                                        }}
                                    >( Click to Reserve Tickets )</p>

                                </div>

                            </div>

















                        </div>





                    </CollapsibleSection_01>



















                </div>

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}






































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}



                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 16, 2026
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginBottom: '0rem',
                                    textDecoration: 'line-through'
                                }}>
                                LAUNCH SITE EVENT - Auburn, MA
                                {/* <br></br><br></br>
                                <span style={{ padding: '1rem' }}>10:00 am - 5:00 pm</span>
                                <br></br> */}
                                {/* 15 Upland St, Auburn, MA 01501 */}
                                {/* At Launch Site 12 pm - 2 pm */}
                            </h1>


                            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                    <p style={{
                                        padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center',
                                        fontFamily: 'orbitron_medium',
                                        color: colors.accentColor,
                                        textDecoration: 'line-through'

                                    }}>10:00 am - 5:00 pm</p>
                                </div>
                            </div>



                            {/* <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        DUE TO A SEVERE WEATHER ALERT FOR MONDAY MARCH 16
                                        <br></br>THE LAUNCH CELEBRATION HAS BEEN MOVED UP 2 DAYS
                                    </p>
                                    <p style={({ fontWeight: 'bold', color: '#f01919' })}
                                    >
                                        THIS EVENT HAS BEEN RESCHEDULED TO
                                        <br></br>SATURDAY MARCH 14 AT 1:00 PM
                                    </p> */}


                            <p style={({ fontWeight: 'bold', color: '#f01919' })}
                            >
                                DUE TO A SEVERE WEATHER ALERT FOR MONDAY MARCH 16
                                <br></br>THE LAUNCH CELEBRATION WAS MOVED UP 2 DAYS
                            </p>
                            <p style={({ fontWeight: 'bold', color: '#f01919' })}
                            >
                                THIS EVENT TOOK PLACE ON
                                <br></br>SATURDAY MARCH 14 AT 1:00 PM
                            </p>


                            <p
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.3rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginTop: '0rem',
                                    color: '#bbbbbb'
                                }}>
                                Address: 15 Upland St, Auburn, MA 01501
                            </p>


                        </div>

                    </div>







                    {/* <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}>
                            <div style={{
                                padding: '0rem',
                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                border: `1px solid ${colors.accentColor}80`,
                                borderRadius: '2rem',
                                maxWidth: '80%',
                            }}>


                                <img
                                    src={SLIDE_04_0819}
                                    alt="IMG_02"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '100%',
                                        //margin: '1rem',
                                        maxHeight: '20rem',
                                        objectFit: 'contain',
                                        // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                        //border: `1px solid ${colors.accentColor}80`,
                                        // borderRadius: '0rem',

                                        padding: '1rem',
                                    }}
                                />


                            </div>
                        </div> */}







                    <img
                        src={LAUNCH_SITE_EVENT_IMAGE}
                        alt="IMG_02"
                        style={{
                            width: 'auto',
                            maxWidth: '80%',
                            margin: '1rem',
                            maxHeight: '20rem',
                            objectFit: 'contain',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '1rem',
                            padding:'0.4rem',
                        }}
                    />


                    {/* <img
                        src={SLIDE_04_0819}
                        alt="IMG_02"
                        style={{
                            width: 'auto',
                            maxWidth: '80%',
                            margin: '1rem',
                            maxHeight: '20rem',
                            objectFit: 'contain',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                        }}
                    /> */}




                    <p style={{ fontSize: '1.3rem', fontWeight: 'bold', textAlign: 'left', marginLeft: '1rem' }}>
                        <a

                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                            class="link_style_01"

                            href="https://www.auburnma.gov/839/Robert-Goddard-Centennial" target="_blank">Details at https://www.auburnma.gov<br></br>/839/Robert-Goddard-Centennial</a>
                    </p>

                    <p style={{ fontSize: '1.3rem', fontWeight: 'bold', textAlign: 'left', marginLeft: '1rem' }}>
                        <a

                            // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                            class="link_style_01"

                            href="https://www.auburnma.gov/839/Robert-Goddard-Centennial" target="_blank">https://goddard100th.org</a>
                    </p>



                    <CollapsibleSection_01
                        title=""
                        summary="100th Anniversary of Dr. Goddard’s historic launch of the world’s first modern rocket."
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                    >
                        <div>

                            <ul>
                                <li style={squareBulletStyle}>
                                    Speeches by: VIP’s / Historians / Etc.
                                </li>

                                <li style={squareBulletStyle}>
                                    Readings from Goddard’s Journal on
                                    March 16 & March 17
                                </li>

                                <li style={squareBulletStyle}>

                                    Model Rocket Launches: 100 model rockets will be launched representing each of the 100 years since Goddard's first launch.


                                    {/* Model Rocket Launches: 100 Goddard
                                    replica rockets will be launched for each
                                    of the 100 years since Goddard’s first
                                    launch. */}
                                </li>

                                {/* <li style={squareBulletStyle}>
                                    (Estes Partnership and Promotion)
                                </li> */}

                                <li style={squareBulletStyle}>

                                    Photo Ops and Selfie Opportunities
                                </li>

                                <li style={squareBulletStyle}>
                                    Live Streaming and Video Documentation
                                    {/* Live Streaming and Documentation
                                        the event. */}
                                </li>

                            </ul>

                            <div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}>


                                <img
                                    src={SLIDE_04_0819}
                                    alt="IMG_02"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '80%',
                                        margin: '1rem',
                                        maxHeight: '20rem',
                                        objectFit: 'contain',
                                        boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                        border: `1px solid ${colors.accentColor}80`,
                                        borderRadius: '2rem',
                                    }}
                                />


                            </div>






                            <p>INSTALLATIONS AT LAUNCH SITE:</p>
                            <ul>
                                <li style={squareBulletStyle}>
                                    Full scale Goddard replica rocket placed near
                                    launch historic marker.
                                </li>

                                <li style={squareBulletStyle}>
                                    Blast shield and observation post replicated.
                                </li>

                                {/* <li style={squareBulletStyle}>
                                    Model Rocket Launches: “100 Goddard
                                    replica rockets will be launched for each
                                    of the 100 years since Goddard’s first
                                    launch
                                </li> */}

                                <li style={squareBulletStyle}>
                                    Photo silhouette cutouts of Goddard, Esther,
                                    and assistants Mr. Rope and Mr. Kisk
                                    (in approximate positions)
                                </li>

                            </ul>






                            {/* <img
                                    src={OBELISK_0910}
                                    alt="IMG_02"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '80%',
                                        maxHeight: '20rem',
                                        objectFit: 'contain',
                                        margin: '1rem',
                                        // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                        // border: `1px solid ${colors.accentColor}80`,
                                        // borderRadius: '2rem',
                                    }}
                                /> */}






                            <div style={{
                                width: '100%',
                                //maxWidth: '600px',
                                display: 'flex',
                                justifyContent: 'center',
                                padding: '1rem',
                            }}>

                                <img
                                    src={OBELISK_0910}
                                    class="glow_border_class"
                                    style={{
                                        maxWidth: '80%',
                                        maxHeight: '300px',
                                        //maxHeight: '15rem',
                                        margin: '2rem',
                                        padding: '0rem',

                                        width: 'auto',
                                        height: 'auto',
                                        borderRadius: '50%',
                                        objectFit: 'contain',
                                        boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                                        border: `1px solid ${colors.cardBorder}80`,

                                    }}
                                />



                            </div>
















                            {/* <div style={{
                                    borderRadius: '2rem',
                                    boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    border: `1px solid ${colors.accentColor}80`,
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                    <img
                                        src={SLIDE_03_0819}
                                        alt="IMG_02"
                                        style={{
                                            width: 'auto',
                                            maxWidth: '80%',
                                            maxHeight: '20rem',
                                            objectFit: 'contain',
                                            margin: '1rem',
                                            // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                            // border: `1px solid ${colors.accentColor}80`,
                                            // borderRadius: '2rem',
                                        }}
                                    />
                                </div> */}



                        </div>
                    </CollapsibleSection_01>
                </div>

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}






















































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}


                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 16
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                }}>
                                All Across The Country
                            </h1>
                        </div>

                    </div>





                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SLIDE_05_0819}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div>



                    {/* <img
                            src={SLIDE_05_0819}
                            alt="IMG_02"
                            style={{
                                width: 'auto',
                                maxWidth: '80%',
                                margin: '1rem',
                                padding: '1rem',
                                maxHeight: '20rem',
                                objectFit: 'contain',
                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                border: `1px solid ${colors.accentColor}80`,
                                borderRadius: '2rem',
                            }}
                        /> */}





                    <CollapsibleSection_01
                        title=""
                        // summary="On the same day, March 16. All over the US, have rocket clubs , NAR, TRA, ARC, ESRA etc. members, plus schools, science centers , etc. will fire off small, medium, and large rockets (even stomp rockets) to celebrate Goddard’s achievements."
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >





                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                        }}>
                            <div
                            // style={{maxWidth:'800px', backgroundColor:'gray'}}
                            >
                                <p>
                                    On the same day, March 16. All over the US, have rocket clubs , NAR, TRA, ARC, ESRA etc. members, plus schools, science centers , etc. will fire off small, medium, and large rockets (even stomp rockets) to celebrate Goddard’s achievements.
                                </p>
                                <p>
                                    Estes Rocket Company will help promote and coordinate. Estes is going to be selling
                                    Goddard replica rockets. “Guinness Book of Records” possibility.

                                </p>
                            </div>

                        </div>





                    </CollapsibleSection_01>
                </div>

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

















































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}


                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 16 - AUGUST 2026
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginBottom: '0rem'
                                }}>
                                Museum of Worcester - Robert Goddard Exhibit
                            </h1>
                        </div>
                        <div>
                            <p
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.3rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginTop: '0rem',
                                    color: '#bbbbbb'
                                }}>
                                Address: 30 Elm Street, Worcester MA
                            </p>
                        </div>
                    </div>





                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SLIDE_06_0819}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div>



                    {/* <img
                            src={SLIDE_06_0819}
                            alt="IMG_02"
                            style={{
                                width: 'auto',
                                maxWidth: '80%',
                                margin: '1rem',
                                maxHeight: '20rem',
                                objectFit: 'contain',
                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                border: `1px solid ${colors.accentColor}80`,
                                borderRadius: '2rem',

                                padding: '1rem',

                            }}
                        /> */}





                    <CollapsibleSection_01
                        title=""
                        summary="March 12 - Robert Goddard Exhibit - [VIP and Press Evening Opening]"
                        summary2="March 16 - Public Opening [Open for 6 Months]"
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                    >
                        <div>

                            <ul>
                                <li style={squareBulletStyle}>
                                    Goddard Exhibit featuring Goddard archives and collections from Clark, WPI,
                                    Smithsonian, Roswell Museum, etc.
                                </li>
                                <li style={squareBulletStyle}>

                                    Esther Goddard Recognition.
                                </li>
                                <li style={squareBulletStyle}>

                                    Kids can touch an actual piece of a Mars meteorite.
                                </li>
                                <li style={squareBulletStyle}>

                                    Goddard Film Festival (running continuously in Fletcher Theater)
                                </li>
                            </ul>

                            <p>





                            </p>
                        </div>
                    </CollapsibleSection_01>
                </div>

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}









































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}


                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div>
                        <h1
                            class="intro_heading_style"
                            style={{
                                fontFamily: 'orbitron_medium',
                                color: colors.accentColor,
                                fontSize: '1.2rem',
                                padding: '0.5rem',
                                color: 'white',
                                textAlign: 'right',
                            }}>
                            MARCH 17-21
                        </h1>
                    </div>
                    <div>
                        <h1
                            class="intro_heading_style"
                            style={{
                                fontFamily: 'orbitron_medium',
                                color: colors.accentColor,
                                fontSize: '1.5rem',
                                padding: '0.5rem',
                                textAlign: 'left',
                            }}>
                            National Space Trail
                        </h1>
                    </div>























                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SPACE_TRAIL_IMAGE}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    opacity: '80%',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div>






























                    <CollapsibleSection_01
                        title=""
                        // summary="On the same day, March 16. All over the US, have rocket clubs , NAR, TRA, ARC, ESRA etc. members, plus schools, science centers , etc. will fire off small, medium, and large rockets (even stomp rockets) to celebrate Goddard’s achievements."
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >





                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                        }}>
                            <div
                            // style={{maxWidth:'800px', backgroundColor:'gray'}}
                            >





                                {/* <p>
                                    <a
                                        style={{
                                            textDecoration: 'none', color: '#cccccc', overflowWrap: 'break-word',
                                        }}

                                        href="https://www.nationalspacetrail.org" target="_blank">
                                        www.nationalspacetrail.org
                                    </a>
                                </p> */}

                                <p style={{ fontWeight: 'bold' }}>

                                    <a

                                        // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                        class="link_style_01"
                                        href="https://www.nationalspacetrail.org" target="_blank">https://<br></br>www.nationalspacetrail.org</a>
                                </p>



                                <p>
                                    Self-Guided Visits
                                </p>





                                <p>
                                    SITES:

                                </p>


                                <ul>
                                    <li style={squareBulletStyle}>
                                        Robert and Esther Goddard House
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Goddard School for Science & Technology (Old South High)
                                    </li>
                                    {/* <li style={squareBulletStyle}>

                                        Mechanics Hall
                                    </li> */}
                                    <li style={squareBulletStyle}>

                                        WPI
                                    </li>

                                    <li style={squareBulletStyle}>

                                        Clark University
                                    </li>

                                    <li style={squareBulletStyle}>

                                        Auburn Launch Site
                                    </li>


                                </ul>


                                {/* 
                                <p>
                                    Also, 4 non-Goddard specific sites:
                                </p>

                                <ul>
                                    <li style={squareBulletStyle}>
                                        Worcester City Hall
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Worcester Airport
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Museum of Worcester
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Ecotarium Science Center
                                    </li>
                                </ul> */}



                                <p>
                                    Supporting Space Trail sites:
                                </p>

                                <ul>
                                    <li style={squareBulletStyle}>
                                        Worcester City Hall
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Worcester Airport / Massport
                                    </li>
                                    <li style={squareBulletStyle}>

                                        Museum of Worcester
                                    </li>
                                    <li style={squareBulletStyle}>

                                        EcoTarium Science Center
                                    </li>
                                </ul>




                            </div>

                        </div>





                    </CollapsibleSection_01>
                </div>

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}






























































































































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}




                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 17-21
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                }}>
                                Robert and Esther Goddard House
                                <br></br><br></br>

                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                        <p style={{ padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center' }}>10:00 am - 12:00 pm</p>
                                        <p style={{ padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center' }}>and</p>
                                        <p style={{ padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center' }}>2:00 pm - 4:00 pm</p>
                                    </div>
                                </div>



                            </h1>
                        </div>



                        <div>
                            <p
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.3rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginTop: '0rem',
                                    color: '#bbbbbb'
                                }}>
                                Address: 1 Tallawanda Dr, Worcester, MA 01603
                            </p>
                        </div>


                    </div>











                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={GODDARD_HOUSE_IMAGE}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',

                                    opacity: '80%',

                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div>













                    {/* <img
                            src={SLIDE_08_0819}
                            alt="IMG_02"
                            style={{
                                width: 'auto',
                                maxWidth: '80%',
                                margin: '1rem',
                                maxHeight: '20rem',
                                objectFit: 'contain',
                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                border: `1px solid ${colors.accentColor}80`,
                                borderRadius: '2rem',

                                padding: '1rem',
                            }}
                        /> */}















                    <CollapsibleSection_01
                        title=""
                        summary="Presentations by Kevin Schindler, historian and author of the new Goddard book: 'Goddard's Massachusetts'"
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >
                        <div>

                        </div>
                    </CollapsibleSection_01>
                </div>





                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

























                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}






                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 17-22
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                }}>
                                {/* Clark and WPI */}
                                Clark University and WPI (Worcester Polytechnic Institute)
                            </h1>
                        </div>

                    </div>








                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SLIDE_09_0819}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div>



                    {/* <img
                            src={SLIDE_09_0819}
                            alt="IMG_02"
                            style={{
                                width: 'auto',
                                maxWidth: '80%',
                                margin: '1rem',
                                maxHeight: '20rem',
                                objectFit: 'contain',
                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                border: `1px solid ${colors.accentColor}80`,
                                borderRadius: '2rem',

                                padding: '1rem',
                            }}
                        /> */}


                    <CollapsibleSection_01
                        title=""
                        // summary="Clark and WPI will be hosting their own events, lectures, tours, and presentations. Specifics TBD"
                        summary=""
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >
                        <div>






                            <p style={{ fontWeight: 'bold' }}>Clark University Events:</p>
                            <p>
                                Full Events List: Robert Goddard Rocket Launch Centennial
                            </p>

                            <p >
                                <a
                                    // style={{
                                    //     textDecoration: 'underline',
                                    //     color: '#5bbaf5',
                                    //     overflowWrap: 'break-word',
                                    // }}

                                    class="link_style_01"
                                    href="https://www.clarku.edu/events/all-campus-events/tag/goddard-centennial/" target="_blank">More Details at:<br></br>www.clarku.edu/events</a>
                            </p>






                            <br></br>
                            <br></br>






                            <p>Clark Goddard Microsite</p>
                            <p>


                            </p>


                            <p >
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href=" https://www.clarku.edu/goddard/" target="_blank">More Details Here

                                    {/* <br></br>www.clarku.edu/events<br></br>/event/john-emond-goddard-vision-reality-hope/ */}

                                </a>
                            </p>
                            <br></br>
                            <br></br>






                            <p>Robert Goddard: A Vision. A Reality. A Hope</p>
                            <p>
                                March 17 @ 7:00 p.m. - 8:00 p.m
                            </p>


                            <p >
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href="https://www.clarku.edu/events/event/john-emond-goddard-vision-reality-hope/" target="_blank">More Details Here

                                    {/* <br></br>www.clarku.edu/events<br></br>/event/john-emond-goddard-vision-reality-hope/ */}

                                </a>
                            </p>



                            <br></br>
                            <br></br>






                            <p>Robert Goddard: The Dreamer Who Launched the Space Age</p>
                            <p>
                                March 19 @ 4:00 p.m. – 6:00 p.m.
                            </p>


                            <p >
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href="https://www.clarku.edu/events/event/robert-goddard-the-dreamer-who-launched-the-space-age/" target="_blank">More Details Here

                                    {/* <br></br>www.clarku.edu/events<br></br>/event/john-emond-goddard-vision-reality-hope/ */}

                                </a>
                            </p>






                            <br></br>
                            <br></br>





                            <p style={{ fontWeight: 'bold' }}>WPI Events:</p><br></br>














                            <p>Pop-up Exhibit #2 ft. WPI's Robert and Esther Goddard Collection: Where the Space Age Began</p>

                            <p>
                                Tuesday, March 17, 2026
                                11:30 a.m. to 1:00 p.m.
                            </p>

                            <p>
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href="https://www.wpi.edu/news/calendar/events/pop-exhibit-2-ft-wpis-robert-and-esther-goddard-collection-where-space-age-began" target="_blank">More Details Here</a>
                            </p>






                            <br></br>
                            <br></br>






                            <p>Pop-up Exhibit #3 ft. WPI’s Robert and Esther Goddard Collection: Where the Space Age Began</p>
                            <p>
                                Wednesday, March 18, 2026
                                12:30 p.m. to 2:00 p.m.
                            </p>
                            <p >
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href="https://www.wpi.edu/news/calendar/events/pop-exhibit-3-ft-wpis-robert-and-esther-goddard-collection-where-space-age-began" target="_blank"> More Details Here</a>
                            </p>








                            <br></br>
                            <br></br>








                            <p>Launching the Next 100 Years: Industry, Innovation & the Future of Space</p>
                            <p>
                                Wednesday, March 18, 2026
                                5:30 p.m. to 7:00 p.m.
                            </p>
                            <p >
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href="https://www.wpi.edu/news/calendar/events/launching-next-100-years-industry-innovation-future-space/" target="_blank"> More Details Here</a>
                            </p>











                            <br></br>
                            <br></br>








                            <p>Goddard's Life and Legacy Exhibits at WPI:</p>

                            <p>
                                A new digital exhibit on Goddard's student years and pioneering work.
                            </p>

                            <p>
                                An interactive physical display will be available March 4, 17, and 18.
                            </p>

                            <p>
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href="https://exhibits.wpi.edu/spotlight/goddard/" target="_blank"> More Details Here</a>
                            </p>

                            <br></br>
                            <br></br>




                            <p>WPI Music at Mechanics Hall</p>
                            <p>
                                Sunday, April 19, 2026
                                4:00 p.m. to 6:00 p.m.
                            </p>
                            <p >
                                <a

                                    // style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} 

                                    class="link_style_01"
                                    href="https://www.wpi.edu/news/calendar/events/wpi-music-mechanics-hall" target="_blank">More Details Here</a>
                            </p>






                            {/* <p>
                                For more information about Clark events go to:
                            </p> */}
                            {/* <p>
                                More details about events at Clark University:
                            </p> */}



                            {/* <span style={{ fontWeight: 'bold' }}>
                                <a style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} href="https://www.clarku.edu/events/all-campus-events/tag/goddard-centennial/" target="_blank">www.clarku.edu/events</a>
                            </span><br></br><br></br> */}


                            {/* <p>
                                <a style={{ textDecoration: 'none', color: 'white' }} href='https://www.clarku.edu/events/event/the-goddard-library-celebrates-robert-goddard/'>
                                    www.clarku.edu/events/event/the-goddard-library-celebrates-robert-goddard/
                                </a>

                            </p> */}


                            {/* <p>
                                More details about events at WPI:
                            </p>


                            <span style={{ fontWeight: 'bold' }}>
                                <a style={{ textDecoration: 'none', color: 'white', overflowWrap: 'break-word', }} href="https://www.wpi.edu/news/calendar/events/launching-next-100-years-industry-innovation-future-space/" target="_blank">www.wpi.edu/news/calendar</a>
                            </span> */}




                            {/* <p>
                                <a style={{ textDecoration: 'none', color: 'white' }} href='https://www.clarku.edu/events/event/the-goddard-library-celebrates-robert-goddard/'>
                                    www.clarku.edu/events/event/the-goddard-library-celebrates-robert-goddard/
                                </a>

                            </p> */}



                        </div>
                    </CollapsibleSection_01>
                </div>







                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}





















                {/* <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 21
                            </h1>
                        </div>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                }}>
                                WPI - Touch Tomorrow Event
                            </h1>
                        </div>

                    </div> */}













                {/* <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SLIDE_10_0819}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div> */}












                {/* <img
                            src={SLIDE_10_0819}
                            alt="IMG_02"
                            style={{
                                width: 'auto',
                                maxWidth: '80%',
                                margin: '1rem',
                                maxHeight: '20rem',
                                objectFit: 'contain',
                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                border: `1px solid ${colors.accentColor}80`,
                                borderRadius: '2rem',

                                padding: '1rem',
                            }}
                        /> */}


                {/* <CollapsibleSection_01
                        title=""
                        summary="WPI will host their popular student oriented “Touch Tomorrow” festival of Science, Technology, and Robots outreach event with a Space and Goddard theme focus."
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >
                        <div>

                        </div>
                    </CollapsibleSection_01>
                </div> */}





















                <div
                    style={{
                        border: `1px solid ${colors.accentColor}80`,
                        width: '100%',
                        margin: '2rem',
                    }}>

                    <div style={{
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                    }}>
                        <div>
                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.2rem',
                                    padding: '0.5rem',
                                    color: 'white',
                                    textAlign: 'right',
                                }}>
                                MARCH 22
                            </h1>
                        </div>
                        <div>
                            {/* <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                }}>
                                The Hanover Theater
                            </h1> */}

                            <h1
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.5rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginBottom: '0.5rem',
                                }}>
                                Goddard Celebration at The Hanover Theater
                                {/* <span style={{ padding: '1rem' }}>4:30 PM - 6:00 PM</span>
                                <br></br> */}




                            </h1>
                            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                    <p style={{
                                        padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center',
                                        fontFamily: 'orbitron_medium',
                                        color: colors.accentColor,

                                    }}>4:30 PM - 6:00 PM</p>

                                    <p style={{
                                        padding: '0rem', margin: '0rem', fontSize: '1.2rem', textAlign: 'center',
                                        fontFamily: 'orbitron_medium',
                                        color: colors.accentColor,

                                    }}>Doors Open at 3:30 pm</p>
                                </div>
                            </div>

                            <p
                                class="intro_heading_style"
                                style={{
                                    fontFamily: 'orbitron_medium',
                                    color: colors.accentColor,
                                    fontSize: '1.3rem',
                                    padding: '0.5rem',
                                    textAlign: 'left',
                                    marginTop: '0rem',
                                    color: '#bbbbbb'
                                }}>
                                Address: 2 Southbridge Street Worcester MA, 01608
                            </p>



                        </div>

                    </div>










                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <div style={{
                            padding: '0rem',
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                            border: `1px solid ${colors.accentColor}80`,
                            borderRadius: '2rem',
                            maxWidth: '80%',
                        }}>


                            <img
                                src={SLIDE_11_0819}
                                alt="IMG_02"
                                style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    //margin: '1rem',
                                    maxHeight: '20rem',
                                    objectFit: 'contain',
                                    // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                    //border: `1px solid ${colors.accentColor}80`,
                                    // borderRadius: '0rem',

                                    padding: '1rem',
                                }}
                            />


                        </div>
                    </div>




















                    <div style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>


                        <div
                            onClick={() => handleLearnMoreClickExternal('https://thehanovertheatre.org/event/goddard-father-of-the-space-age/')}
                            className="div_button_style_02"
                            style={{
                                margin: '1rem', padding: '0.5rem', border: '1px solid white', maxWidth: '700px',

                            }}
                        >
                            <p class="p_style_03"
                                style={{
                                    color: 'white',
                                    textAlign: 'center',
                                    fontSize: '1.5rem',
                                    //fontFamily: 'orbitron_regular', 
                                    padding: '0rem',
                                    margin: '0rem',
                                }}

                            >
                                <b style={{ color: colors.accentColor, letterSpacing: '2px' }}>RESERVE FREE TICKETS NOW!</b>
                            </p>


                            <p class="p_style_03"
                                style={{
                                    color: 'white',
                                    textAlign: 'center',
                                    fontSize: '1.2rem',
                                    // fontFamily: 'orbitron_regular', 
                                    padding: '0rem',
                                    margin: '0rem',
                                }}

                            >
                                for the
                            </p>

                            <p class="p_style_03"
                                style={{
                                    color: 'white',
                                    textAlign: 'center',
                                    fontSize: '1.1rem',
                                    //fontFamily: 'orbitron_regular', 
                                    padding: '0rem',
                                    margin: '0rem',
                                }}

                            >
                                Goddard Hanover Theater Celebration
                            </p>


                            <p class="p_style_03"
                                style={{
                                    color: 'white',
                                    textAlign: 'center',
                                    fontSize: '1.1rem',
                                    //fontFamily: 'orbitron_regular', 
                                    padding: '0rem',
                                    margin: '0rem',
                                }}

                            >
                                Sunday, March 22nd, 4:30pm
                            </p>

                            <p class="p_style_03"
                                style={{
                                    padding: '0rem',
                                    margin: '0rem',
                                    fontSize: '1rem',
                                    textAlign: 'center',
                                    color: "white",
                                }}
                            >( Click to Reserve Tickets )</p>

                        </div>

                    </div>



























                    {/* <img
                            src={SLIDE_11_0819}
                            alt="IMG_02"
                            style={{
                                width: 'auto',
                                maxWidth: '80%',
                                margin: '1rem',
                                maxHeight: '20rem',
                                objectFit: 'contain',
                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                                border: `1px solid ${colors.accentColor}80`,
                                borderRadius: '2rem',

                                padding: '1rem',
                            }}
                        /> */}



                    {/* Featured event at The Hanover Theater (family friendly with focus on students and education) */}

                    <CollapsibleSection_01
                        title=""
                        summary="FREE Family Friendly Event at The Hanover Theater (with focus on students and education) "
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                    >
                        <div style={{ margin: '1rem' }}>




                            <p>
                                4:30 PM Start Time ( Doors open at 3:30pm )


                            </p>

                            <p>
                                Emcee: Maynard Okereke ("Hip Hop Science") https://<br></br>www.hiphopscienceshow.com/
                            </p>



                            <ul>
                                <li style={squareBulletStyle}>
                                    Keynote and VIP Speakers:

                                    {/* (Dr. Mckenzie Lystrup and Dr. Alan Stern) */}
                                    <br></br><br></br>
                                    <ul>
                                        <li>
                                            Dr. Mckenzie Lystrup - Former Director NASA Goddard Flight Center
                                        </li>

                                        <li>
                                            Dr. Alan Stern - Planetary Scientist, Commercial Astronaut, Space Explorer
                                        </li>

                                        <li>
                                            Dr. Daniel Hastings - President of AIAA

                                        </li>

                                        <li>
                                            Astronaut and Massachusetts Native - Dr. Al Sacco Jr.
                                        </li>
                                    </ul>
                                    <br></br>
                                </li>
                                {/* <li style={squareBulletStyle}>

                                    A Massachusetts Astronaut

                                </li> */}
                                <li style={squareBulletStyle}>

                                    Video Testimonials from around the World
                                </li>
                                <li style={squareBulletStyle}>

                                    Local students reading Goddard's valedictory famous speech
                                </li>

                                {/* 
                                <li style={squareBulletStyle}>
                                    Awards to Teachers, Students, Big Dreamers
                                </li> */}
                                <li style={squareBulletStyle}>
                                    First Esther Goddard Award
                                </li>
                                <li style={squareBulletStyle}>
                                    3 Minute "History of Space" Video
                                </li>
                                <li style={squareBulletStyle}>
                                    New "Goddard The Visionary" 6 Minute Video
                                </li>
                                <li style={squareBulletStyle}>
                                    And premiering an original song about Goddard
                                </li>

                            </ul>






                            {/* <p>
                                4:30 PM Start Time


                            </p>


                            <ul>
                                <li style={squareBulletStyle}>
                                    Keynote and VIP Speakers (TBD)
                                </li>
                                <li style={squareBulletStyle}>

                                    Astronauts
                                </li>
                                <li style={squareBulletStyle}>

                                    Video Testimonials from around the World and ISS
                                </li>
                                <li style={squareBulletStyle}>

                                    Local students reading Goddard's valedictory famous speech
                                </li>


                                <li style={squareBulletStyle}>
                                    Awards to Teachers, Students, Big Dreamers
                                </li>
                                <li style={squareBulletStyle}>
                                    First Esther Goddard Award
                                </li>
                                <li style={squareBulletStyle}>
                                    2 Minute "History of Space" Video
                                </li>
                                <li style={squareBulletStyle}>
                                    New "Goddard The Visionary" 6 Minute Video
                                </li>
                                <li style={squareBulletStyle}>
                                    Etc.
                                </li>

                            </ul>


                            <p>
                                Tentative Emcee: Maynard Okereke ("Hip Hop Science") https://www.hiphopscienceshow.com/
                            </p> */}


                        </div>
                    </CollapsibleSection_01>
                </div>
































                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

                {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
























            </div>

















































            {/* // As  Goddard once said: “It is difficult to say what is impossible, for the dream of yesterday is the hope of today and the reality of tomorrow. */}
            <div class="section_style">

                <DonateComponent></DonateComponent>

            </div>
















            {/* <p class="p_style_01"
                    style={{ backgroundColor: 'rgba(25, 171, 240,0.20)', padding: '1rem', borderRadius: '1rem', cursor: 'pointer' }}
                    onClick={() => handleLearnMoreClick('/about')}
                >
                    <b>The Wonder Mission</b>
                </p> */}





            {/* <div class="section_style">

                <p class="p_style_01">
                    An Initiative of
                </p>




                <p class="p_style_01"
                    style={{ backgroundColor: 'rgba(25, 171, 240,0.20)', padding: '1rem', borderRadius: '1rem', cursor: 'pointer' }}
                    onClick={() => handleNavigateAndScroll('/about')}
                >
                    <b>The Wonder Mission</b>
                </p>







                <h3 style={{ color: colors.accentColor, margin: '1rem' }}>Subscribe to Our Newsletter!</h3>
                <div style={{ borderRadius: '2rem', margin: '1rem' }}>

                    <NewsletterForm>

                    </NewsletterForm>
                </div>


                
            </div> */}





















            {/* // As  Goddard once said: “It is difficult to say what is impossible, for the dream of yesterday is the hope of today and the reality of tomorrow. */}
            {/* <div class="section_style">
                <CollapsibleSection_01
                    title="title section which appears as bold and blue"
                    summary="summary section which appears as regular and white"
                    //imageSrc=''
                    imageAlt=""
                    fullText=" "
                    learnMoreLink="learnMoreLink"
                    learnMoreText="learnMoreText"
                    delay={0.0}
                >
                    <div style={{
                        //backgroundColor: 'gray',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    >
                        <p style={{
                            width: '100%',
                            //backgroundColor: 'red',
                            fontSize: '1.3rem',
                            padding: '0rem',
                            margin: '1rem',
                            textAlign: 'left',
                        }}>

                            The dropdown menu can contain additional text.
                        </p>
                    </div>



                </CollapsibleSection_01>
            </div> */}






        </PageWrapper >
    )

}

export default CentennialPageRefactor;

